import React from "react";
import MomentFormatter from "../../utils/MomentFormatter";
import {DateInput} from "@blueprintjs/datetime";

function FormattedDateInput({name, value, onChange, inputRef = null, showOnlyFuture = false, showOnlyPast = false, placeHolder="", fullWidth=false}){
    let minDate = new Date(new Date().setFullYear(1945));
    let maxDate = (d => new Date(d.getFullYear() + 100, d.getMonth(), d.getDate()))(new Date());

    if(showOnlyFuture && showOnlyPast === false){
        minDate = new Date();
    }

    if(showOnlyPast && showOnlyFuture === false){
        maxDate = new Date();
    }


    return (
        <DateInput
            {...MomentFormatter.datePickerFormatProps()}
            popoverProps={{
                usePortal: false
            }}
            inputProps={{
                inputRef: inputRef,
                name: name,
                fill: fullWidth
            }}
            fill={fullWidth}
            minDate={minDate}
            maxDate={maxDate}
            onChange={onChange}
            placeholder={placeHolder === "" ? "Wprowadź datę w formacie rrrr-mm-dd" : placeHolder}
            value={value} />
    );
}

export default FormattedDateInput;